import { Link } from "react-router-dom";
import { PlaneTakeoff, Compass, Crown, Building2, ArrowRight } from "lucide-react";
import { usePageSeo } from "@/hooks/usePageSeo";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageHero from "@/components/PageHero";
import heroImg from "@/assets/hero-services.jpg";

const services = [
  { icon: PlaneTakeoff, title: "Airport Transfers", text: "Private door-to-door pickup and drop-off from PUJ, SDQ, STI, POP and more.", href: "/transfers" },
  { icon: Building2, title: "Hotel Shuttles", text: "Reliable hotel-to-hotel and resort transfers across the entire island.", href: "/transfers" },
  { icon: Compass, title: "Curated Tours", text: "Saona, Catalina, Samaná, ATV adventures, catamaran days and more.", href: "/tours" },
  { icon: Crown, title: "VIP & Group Service", text: "Luxury vehicles, executive travel and large-group coordination.", href: "/contact" },
];

const ServicesPage = () => {
  usePageSeo("services");
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <PageHero
        eyebrow="Services"
        title={<>Everything you need <span className="italic text-gradient-ocean">on the island.</span></>}
        subtitle="One trusted partner for every type of journey across the Dominican Republic."
        image={heroImg}
      />

      <section className="container mx-auto px-4 py-20 grid md:grid-cols-2 gap-6">
        {services.map((s) => (
          <Link
            key={s.title}
            to={s.href}
            className="group relative overflow-hidden rounded-3xl bg-gradient-card p-8 shadow-card border border-border/60 hover:shadow-elegant transition-smooth"
          >
            <div className="w-14 h-14 rounded-2xl bg-gradient-ocean text-primary-foreground flex items-center justify-center shadow-glow">
              <s.icon className="w-6 h-6" />
            </div>
            <h3 className="font-display text-2xl font-semibold mt-5">{s.title}</h3>
            <p className="text-muted-foreground mt-2 leading-relaxed">{s.text}</p>
            <div className="mt-6 inline-flex items-center gap-2 text-primary font-semibold">
              Learn more <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </div>
          </Link>
        ))}
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;
